import { ExclamationCircleFilled } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  title: string;
  description?: string;
  onConfirm: () => void | Promise<void>;
  /** When true the popover doesn't open on trigger click. */
  disabled?: boolean;
  /** The trigger — usually a <Button>. Popconfirm wraps it. */
  children: ReactElement;
};

/**
 * AntD Popconfirm preset with the BMO warning-icon + "common.yes" / "common.no"
 * button labels. Eliminates the inline ExclamationCircleFilled + okText/cancelText
 * boilerplate that appears around every destructive or state-changing action.
 */
export function ConfirmPopover({ title, description, onConfirm, disabled, children }: Props) {
  const { t } = useTranslation();
  return (
    <Popconfirm
      title={title}
      description={description}
      icon={<ExclamationCircleFilled style={{ fontSize: 22, color: '#ad6800' }} />}
      okText={t('common.yes')}
      cancelText={t('common.no')}
      onConfirm={onConfirm}
      disabled={disabled}
    >
      {children}
    </Popconfirm>
  );
}
